// Global
import React from 'react';

// Local
import styles from './EmbeddedVideo.module.scss';
import clsx from 'clsx';
import EmbeddedVideo from 'components/helpers/Video/EmbeddedVideo';

export interface EmbeddedVideoProps {
  videoId: string;
  videoTitle: string;
  videoThumbnailUrl: string;
  videoWithAudioDescriptionURL: string;
  videoTranscriptFileUrl: string;
  isPortrait: boolean;
  videoUrl?: string;
  videoType?: string;
  ctaLinksLeftAligned?: boolean;
  noPadding?: boolean;
}

export const EmbeddedVideoMain = (props: EmbeddedVideoProps) => {
  /*
   * Rendering
   */

  return (
    <div
      className={clsx({
        [styles.embeddedVideoWithPadding]: !props.noPadding,
        [styles.embeddedVideoNoPadding]: props.noPadding,
      })}
    >
      <EmbeddedVideo
        videoId={props.videoId}
        videoTitle={props.videoTitle}
        videoThumbnailUrl={props.videoThumbnailUrl}
        videoWithAudioDescriptionURL={props.videoWithAudioDescriptionURL}
        videoTranscriptFileUrl={props.videoTranscriptFileUrl}
        isPortrait={props.isPortrait}
        videoUrl={props.videoUrl}
        videoType={props.videoType}
        ctaLinksLeftAligned={true}
      />
    </div>
  );
};
